import { withInstall } from '@tw-element/utils'

import Empty from './src/empty.vue'

export const TwEmpty = withInstall(Empty)
export default TwEmpty

export * from './src/empty'
